import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/nota_debito_planilla';
import Notas from './NotaDebitoList';


const ms2p = (state) => {
  return {
    ...state.vm_nota_debito_planilla,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Notas);
